import i18n from 'i18n';
import { InferType, mixed, number, object, string } from 'yup';

import { ALLOWED_EXTENSIONS, isValidExtension } from '../UploadDropzone/constants';
import type { Status } from '../UploadPreview/types';

export const imageFileSchema = object({
  id: number().optional(),
  data: string(),
  name: string().test(
    'supported-files',
    i18n.t('common:validation.unsupportedFileType', {
      supportedExtensions: ALLOWED_EXTENSIONS.image,
      type: 'disjunction',
    }),
    (name) => !name || isValidExtension(name, 'image')
  ),
  size: number(),
  url: string(),
  type: string(),
  status: mixed<Status>(),
  progress: number(),
});

export type ImageFile = InferType<typeof imageFileSchema>;

export const isSelectedImageFile = (file: ImageFile): boolean => !!file.data && file.data.startsWith('data:');

export const isRemoteImageFile = (file: ImageFile): boolean => !!file.data && string().url().isValidSync(file.data);
